import { connect } from 'react-redux';
import RootOptionGroup from './RootOptionGroup';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  hasEmployer: state.session.hasEmployer
});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RootOptionGroup);



// WEBPACK FOOTER //
// ./src/components/RootOptionGroup/index.js